module.exports = __webpack_public_path__ + "img/hover_icon_manejo_asistente_servicios.b0a8a6ca.svg";